import React from "react";
import { useIsMobile } from "@/app/redux/features/device/selectors";
import ArrowRightIcon from "@/app/shared-components/icons/ArrowRightIcon";

const specsData = [
  {
    img: "/assets/images/christmas-raffle/icon-ticket.svg",
    description: (
      <>
        Enter to Earn
        <br />
        Draw Tickets
      </>
    ),
  },
  {
    img: "/assets/images/christmas-raffle/icon-gift.svg",
    description: (
      <>
        Win Daily
        <br />
        Prizes
      </>
    ),
  },
  {
    img: "/assets/images/christmas-raffle/icon-confetti.svg",
    description: (
      <>
        Enter The
        <br />
        Grand Finale
      </>
    ),
  },
];

export const Steps = () => {
  const isMobile = useIsMobile();

  return (
    <div className="w-full">
      <div className="flex items-center max-lg:justify-center pl-[9px] lg:pl-3 gap-5 lg:gap-8 font-jost">
        {specsData.map((item, index) => (
          <React.Fragment key={index}>
            <div className="flex items-center min-w-0 gap-2">
              <div className="relative shrink-0 size-6 lg:size-10">
                <img src={item.img} alt="" width={40} height={40} className="size-full" />

                <div className="flex items-center justify-center absolute -top-[9px] lg:-top-3 -left-[9px] lg:-left-3 size-4.5 lg:size-6 text-xs lg:text-base font-semibold leading-4 lg:leading-5.5 text-white bg-[#E87600] rounded-full">
                  {index + 1}
                </div>
              </div>

              <div className="text-xs lg:text-xl font-medium leading-4 lg:leading-6.5 text-white">
                {item.description}
              </div>
            </div>

            {index < specsData.length - 1 && (
              <ArrowRightIcon variant={3} className="hidden lg:block size-4 shrink-0 text-white opacity-38" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
